<template>
    <div class="pa-5">
        Перевод согласно текущему языку:
        {{ itemsTranslated.name }}
    </div>
</template>

<script>
import translate from '../utils/translate.util';
export default {
    data: () => ({
        objectInTwoLangs: {
            name___kz: 'Салем',
            name___ru: 'Привет'
        }
    }),
    computed: {
        itemsTranslated() {
            // первый параметр - данные из БД, которые нужно перевести
            // второй параметр: full - переводить всё, где встречается постфиксы ___kz или ____ru, part - переводить только label___kz или label___ru
            return translate(this.objectInTwoLangs, 'full');
        }
    }
};
</script>

<style></style>
